import React, { Component } from 'react'
import './style.css'

class Resume extends Component {
  render () {
    return (
      <div className='books-main-container'>
        <div className='grants-and-awards-title-div'>
          <h1 className='resume-main-title'>Resume</h1>
          <img src='https://i.imgur.com/1KMe3ta.png' className='car-photo-resume' alt='' />
        </div>
        <div className='resume-info-main-container'>
          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>Full-time Freelance Medical Editor, WebMD/ Medscape </h3>
              <p className='resume-title-city-date'>New York, NY: October 2016–Present</p>
            </div>
            <div className='resume-info-div'>
              <p className='resume-text'>
                Copyediting, proofreading, grammar, use of Stedman’s Medical Dictionary and AMA
                style across digital platforms for initial scripts, initial builds, brand and MLR
                feedback to scripts and builds, tagging and tracking codes, and final products
              </p>
              <ul className='resume-bullet-text-container'>
                <li className='resume-bullet-text'>Handled tasks using Workfront, Box, Proof HQ and other applications</li>
                <li className='resume-bullet-text'>
                  Text and ISIs for diverse indications, including oncology, hematology, pulmonary,
                  HIV, neurology, dermatology, cardiology, diabetes and others for diverse clients,
                  both global (Germany, Italy and others) and U.S. including Pfizer, Eli Lilly,
                  Sanofi, Bayer, GSK, Novartis, Merck, and others
                </li>
              </ul>
            </div>
          </div>

          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>Medical Editor</h3>
              <p className='resume-title-city-date'>Grey Advertising, Men’s Health</p>
              <p className='resume-title-city-date-2'>New York NY: December 2015–October 2016</p>
            </div>
            <div className='resume-info-div'>
              <p className='resume-text'>
                Copyediting, proofreading, fact checking, grammar and AMA style for Eli Lilly products
              </p>
            </div>
          </div>
          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>Senior Editor</h3>
              <p className='resume-title-city-date'>H4B Chelsea/Havas Health,</p>
              <p className='resume-title-city-date-2'>New York NY: Full-time on staff October 2013–November 2015;</p>
              <p className='resume-title-city-date-3'>Freelance in-house November 2011–October 2013</p>
            </div>
            <div className='resume-info-div'>
              <p className='resume-text'>
                Copyediting, proofreading, fact checking, grammar and AMA style primarily for Astellas
                products and for Alcon contact lenses and ophthalmological products
              </p>
            </div>
          </div>
          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>Editorial Services and Publications Consultant: </h3>
              <p className='resume-title-city-date'>Project based or less than a year per client</p>
            </div>
            <div className='resume-info-div'>
              <p className='resume-text'>
                Design, writing, editing, copyediting, proofreading, typesetting, printing, layout and
                production of books, magazines, brochures and posters (specifics per client and further
                details available upon request)
              </p>
              <ul className='resume-bullet-text-container'>
                <li className='resume-bullet-text'>
                  Clients have included McGraw-Hill Education (the
                  Encyclopedia and Yearbook of Science and Technology); Cape Cod Compositors (including
                  projects for John Wiley and Sons); Galen Press; Namta Press; HC Language Solutions;
                  House of Nehesi Publishers; PreMedia Global for Pearson Prentice-Hall; Prof-Edit
                  (including projects for John Wiley and Sons, Facts on File, The College Board, Chelsea House,
                  New York State Statistical Yearbook, Cambridge University Press); Cardozo School of Law,
                  Yeshiva University; Merce Cunningham Dance Foundation; The Franklin Library; Stonehill
                  Publishing Company; Sojourner Truth Printing Collective; People’s Printing Cooperative;
                  numerous authors, filmmakers and composers
                </li>
              </ul>
            </div>
          </div>
          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>Executive Director of Marketing</h3>
              <p className='resume-title-city-date'>
                Terra Holdings/Brown Harris Stevens/Halstead Property,
                New York NY: 1998–2003
              </p>
            </div>
            <div className='resume-info-div'>
              <ul className='resume-bullet-text-container'>
                <li className='resume-bullet-text'>Proposed and implemented an in-house marketing materials program for 575 brokers</li>
                <li className='resume-bullet-text'>Generated hundreds of thousands of materials including show sheets, postcards, newsletters</li>
                <li className='resume-bullet-text'>Provided writing and editorial services to Brown Harris Stevens residential sales division</li>
                <li className='resume-bullet-text'>Wrote style book for all corporate divisions </li>
                <li className='resume-bullet-text'>In charge of purchasing equipment and materials and budgeting for publications program</li>
                <li className='resume-bullet-text'>Wrote biographical profiles of real estate brokers for Brown Harris Stevens website</li>
                <li className='resume-bullet-text'>Served residential and commercial sales, mortgage, insurance and management divisions</li>
                <li className='resume-bullet-text'>Utilized desktop publishing programs incorporating digitalized images and web-based text</li>
              </ul>
            </div>
          </div>
          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>Publisher, Vehicle Editions</h3>
              <p className='resume-title-city-date'>New York NY: 1976–Present</p>
            </div>
            <div className='resume-info-div'>
              <ul className='resume-bullet-text-container'>
                <li className='resume-bullet-text'>Founded company, developed and managed collaborative business and artistic projects</li>
                <li className='resume-bullet-text'>Responsible for editorial work, design, production, book printing and binding</li>
                <li className='resume-bullet-text'>Find further details at www.vehicleeditions.com</li>
              </ul>
            </div>
          </div>
          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>U.S. Sales Representative</h3>
              <p className='resume-title-city-date'>Printing and Binding Services</p>
            </div>
            <div className='resume-info-div'>
              <ul className='resume-bullet-text-container'>
                <li className='resume-bullet-text'>Arti Grafiche Motta, Milan, Italy and New York NY 1988–1990</li>
                <li className='resume-bullet-text'>Comproject BV, Baarn, Holland and New York NY 1984–1986</li>
              </ul>
            </div>
          </div>

          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>Production Manager</h3>
              <p className='resume-title-city-date'>Aperture Foundation, New York NY: 1986–1987</p>
            </div>
            <div className='resume-info-div'>
              <ul className='resume-bullet-text-container'>
                <li className='resume-bullet-text'>Book and magazine production and on-press quality control</li>
              </ul>
            </div>
          </div>

          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>Education</h3>
            </div>
            <div className='resume-info-div'>
              <p className='resume-text'>
                Copyediting, proofreading, grammar, use of Stedman’s Medical Dictionary and AMA
                style across digital platforms for initial scripts, initial builds, brand and MLR
                feedback to scripts and builds, tagging and tracking codes, and final products
              </p>
              <ul className='resume-bullet-text-container'>
                <li className='resume-bullet-text'>M.A., Montclair State University, Montclair NJ: education and literacy</li>
                <li className='resume-bullet-text'>B.A., SUNY, Empire State College, New York NY: creative writing and literatures</li>
                <li className='resume-bullet-text'>Sarah Lawrence College, Bronxville NY: majored in creative writing and literature</li>
                <li className='resume-bullet-text'>
                  French language proficiency; German language (NYU Deutsches Haus); Italian language
                  (Pratt Institute); Spanish language (The Spanish Institute and Berlitz); Russian language (Columbia University
                  and The New School)
                </li>
              </ul>
            </div>
          </div>

          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>Grants and Awards</h3>
            </div>
            <div className='resume-info-div'>
              <ul className='resume-bullet-text-container'>
                <li className='resume-bullet-text'>Fast Lanes by Jayne Anne Phillips (Vehicle Editions): International Gallery of Superb Printing Award</li>
                <li className='resume-bullet-text'>Smithsonian Depositions by Clark Coolidge (Vehicle Editions): nominated for the Pushcart Prize</li>
                <li className='resume-bullet-text'>just let me do it by Michael Lally (Vehicle Editions): finalist for the Elliston Book Award</li>
                <li className='resume-bullet-text'>New York State Council on the Arts, Literature Program, Publications Grant</li>
                <li className='resume-bullet-text'>Counting by Jayne Anne Phillips (Vehicle Editions): St. Lawrence Award for Fiction</li>
                <li className='resume-bullet-text'>National Endowment for the Arts, Small Press Grant, Two Fellowships to the Editor</li>
              </ul>
            </div>
          </div>

          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>Publications</h3>
            </div>
            <div className='resume-info-div'>
              <p className='resume-text'>
                Basket, Selected Poems, Accent Editions, Chester NY; At the Heart of the World by Blaise Cendrars,
                translation from the French, O Press, New York NY; Essay Confessions of a Teacher in a “No Excuses”
                Charter School published by Diane Ravitch on her blog
                http://dianeravitch.net/2014/03/27/confessions-of-a-teacher-in-a-no-excuses-charter-school/;
                Essays The natural connection and A market correction in local real estate appeared in The
                Chatham Press; On Hudson, web content for www.hudsoncityradio.com; Essay included in A Secret
                Location on the Lower East Side: Adventures in Writing 1960-1980 by Rodney Phillips and Steven
                Clay, The New York Public Library and Granary Books, New York NY; Craft International Magazine
                commissioned the essay “Confessions of a Publisher”; poetry and prose published in approximately
                50 magazines and anthologies
              </p>
            </div>
          </div>

          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <h3 className='resume-bold-title'>Professional Affiliations</h3>
              <p className='resume-title-city-date'>New York, NY: October 2016–Present</p>
            </div>
            <div className='resume-info-div'>
              <p className='resume-text'>
                Member of the Board of Directors, The Poetry Project at St. Mark’s Church in the Bowery, New York NY
              </p>
              <p className='resume-text'>
                Former member of the Board of Directors, Center for Book Arts, New York NY
              </p>
            </div>
          </div>

          <div className='resume-info-chunk'>
            <div className='resume-title-div'>
              <p className='resume-text-last'>References available on request</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Resume
